module.exports = __webpack_public_path__ + "img/splitter-west.e768f122.png";